// extracted by mini-css-extract-plugin
export default {"root":"EarnRewards_root__3Tip1","star":"EarnRewards_star__3Wjs0"};